import { defineComponent as _defineComponent } from 'vue';
import { BButton } from "bootstrap-vue";
import { computed } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ActivityPanel',
    props: {
        title: null,
        goToAllTitle: { default: undefined },
        href: { default: undefined },
        goToOnHref: { type: Boolean }
    },
    emits: ["goToAll"],
    setup(__props, { emit }) {
        const props = __props;
        const hasGoToAll = computed(() => props.goToAllTitle && props.href);
        return { __sfc: true, props, emit, hasGoToAll, BButton };
    }
});
